import FormControlLabel from "@mui/material/FormControlLabel";

export default FormControlLabel;
